import script from "./security-status.vue?vue&type=script&lang=ts&setup=true"
export * from "./security-status.vue?vue&type=script&lang=ts&setup=true"

import "./security-status.vue?vue&type=style&index=0&id=0cc5b063&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc5b063"]])

export default __exports__